import ModalTabs from '../../../../../../../../baseComponents/ModalsLayouts/ModalTabs';
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types';
import { RowData } from '../../../../../../../../baseComponents/TwinTable/types';
import { useBasicData } from '../../../../../../../../utils/hooks/useBasicData';
import { ComponentTabObject } from '../../../../../../../../utils/hooks/useTabLogic';
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation';
import { getUserPermissions } from '../../../../../../../../utils/reducers/getters';
import FeaturesProductQuoteTab from './Tabs/FeaturesProductQuoteTab';
import MainEditProductOrderTab from './Tabs/MainEditProductOrderTab';
import OtherInformationEditProductOrderTab from './Tabs/OtherInformationEditProductOrderTab';
import ProductComposedOrderTab from './Tabs/ProductComposedOrderTab';
import SpecificPricesProductTab from './Tabs/SpecificPricesProductTab';
import StockProductQuoteTab from './Tabs/StockProductQuoteTab';
import SuppliersProductQuoteTab from './Tabs/SuppliersProductQuoteTab';

interface ModalEditProductOrderProps extends ModalEditComponentProps {}

const ModalEditProductOrder: React.FC<ModalEditProductOrderProps> = ({ ...rest }) => {
    const { t } = useTwinTranslation()
    const { basicData } = useModalEditProductOrder(rest)
    const tabs: ComponentTabObject = {
        'main': { component: MainEditProductOrderTab, text: t('main', 'Principal'), permission: 'product.profile.main' },
        'features': { component: FeaturesProductQuoteTab, text: t('features', 'Características'), permission: 'product.profile.features' },
        'suppliers': { component: SuppliersProductQuoteTab, text: t('suppliers', 'Proveedores'), permission: 'product.profile.supplier' },
        'stock': { component: StockProductQuoteTab, text: t('stock', 'Inventario'), permission: 'product.profile.stock' },
        'prices': { component: SpecificPricesProductTab, text: t('prices', 'Precios'), permission: 'product.profile.specificPrice' },
        'other-information': { component: OtherInformationEditProductOrderTab, text: t('otherInformation', 'Otra información'), permission: 'product.profile.main' },
        'product-composed': { component: ProductComposedOrderTab, text: t('productComposed', 'Producto Compuesto'), permission: 'product.profile.productComposed' },
    }
    const permissions: any = {
        'product.profile.features': getUserPermissions('product.profile.features'),
        'product.profile.supplier': getUserPermissions('product.profile.supplier'),
        'product.profile.stock': getUserPermissions('product.profile.stock'),
        'product.profile.specificPrice': getUserPermissions('product.profile.specificPrice'),
        'product.profile.main': getUserPermissions('product.profile.main'),
        'product.profile.productComposed': getUserPermissions('product.profile.productComposed')
    }
    return (
        <ModalTabs {...rest} tabs={tabs} tab={rest.allRowData ? rest.allRowData['_defaultTab'] : 'main'} extraComponentData={{ basicData, ...rest.allRowData }} userPermissions={permissions} skipAntiUnsaveItems={['sellTicket']} />
    )
}
type ModalEditProductOrderLogicProps = {
    allRowData?: RowData
}

const useModalEditProductOrder = ({ allRowData }: ModalEditProductOrderLogicProps) => {
    const ProductId = allRowData?.ProductId
    const { basicData } = useBasicData({ params: { id: ProductId }, url: '/api/app/product/getProductInstanceComplete'})

    return {basicData}
}


export default ModalEditProductOrder;